// extracted by mini-css-extract-plugin
module.exports = {"loadingStimulator":"loading_container_loadingStimulator__3sywl"};